import { portalPath, useApiContext } from '@servicetim/ui/api';
import { useMutation } from '@tanstack/react-query';

/*
 * Approvals, the notification inbox and preferences moved to real hooks in
 * `@servicetim/ui/api` (`use-approvals.ts`, `use-notifications.ts`) once Bolt 8 shipped those
 * endpoints — screens import them from `@/api` same as before, they just resolve to
 * `@servicetim/ui/api` now instead of the tolerant adapters that used to live in this file.
 *
 * The one thing left here is the self profile update: there is no self-service profile
 * endpoint yet (users are edited by admins through `/admin/v1/users/{id}`); until one exists
 * this answers 404 and the profile screen stays read-only with a note.
 */
export function useUpdateMe() {
  const { request, keys, invalidate } = useApiContext();
  return useMutation({
    mutationFn: (patch: { displayName?: string; timezone?: string | null }) =>
      request<unknown>('PATCH', portalPath('/me'), { body: patch }),
    onSuccess: () => invalidate([...keys.all, 'portal', 'me']),
  });
}
